import { Grid } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Region } from '~/shared/api'
import { getPhoneMaskByCountry } from '~/shared/config/countryConfig'
import { AsyncAutocompleteInput, MaskInput, TextInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type MainProps = {
  disabled?: boolean
  skeletonShow?: boolean
}

export function Main({ disabled, skeletonShow }: MainProps) {
  const { t } = useTranslation()
  return (
    <Container data-testid='main-form-container'>
      <ContainerTitle>{t('basic information')}</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={4}>
          <TextInput
            label='form.last name'
            placeholder='form.enter last name'
            name='lastName'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <TextInput
            label='form.first name'
            placeholder='form.enter first name'
            name='firstName'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={4}>
          <TextInput
            label='form.middle name'
            placeholder='form.enter middle name'
            name='middleName'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <TextInput
            label='form.E-mail'
            placeholder='form.enter E-mail'
            name='email'
            readOnly={disabled}
            skeletonShow={skeletonShow}
          />
        </Grid>
        <Grid xs={6}>
          <MaskInput
            label='form.phone'
            placeholder='form.enter phone'
            name='phone'
            skeletonShow={skeletonShow}
            readOnly={disabled}
            mask={getPhoneMaskByCountry()}
          />
        </Grid>
        <Grid xs={12}>
          <AsyncAutocompleteInput
            label='form.region of work'
            placeholder='form.select the region'
            name='regionId'
            fetchOptions={Region.fetchOptions}
            skeletonShow={skeletonShow}
            readOnly={disabled}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
